import { Spin } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoCircleFilled } from '@ant-design/icons';

import PlumbingModal from './components/PlumbingModal.component';
import useSidePanelPlumbing from './utils/useSidePanelPlumbing';

import ItemCountAdjustButton from '~atoms/ItemCountAdjustButton';
import DesignStepContainer from '~molecules/DesignStepContainer';
import DesignSectionCard from '~organisms/DesignSectionCard';
import DesignSectionHeader from '~organisms/DesignSectionHeader';

const SidePanelPlumbingTab = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const {
    plumbingDisplayData,
    isFetchingPlumbing,
    arePlumbingAvailable,
    handlePlumbingClick,
    increaseQuantity,
    decreaseQuantity,
    setQuantity,
  } = useSidePanelPlumbing();

  if (!arePlumbingAvailable) {
    return null;
  }

  return (
    <>
      <DesignSectionHeader
        title={t('SCROLLABLE_AREA.PLUMBING.TITLE')}
        description={t('SCROLLABLE_AREA.PLUMBING.DESCRIPTION')}
      >
        <InfoCircleFilled
          style={{
            fontSize: '26px',
            color: '#1890ff',
            cursor: 'pointer',
            paddingLeft: '8px',
            position: 'relative',
            top: '8px',
          }}
          onClick={() => setIsModalVisible(true)}
        />
      </DesignSectionHeader>

      {isFetchingPlumbing ? (
        <Spin style={{ fontSize: 24, marginLeft: '40%' }} />
      ) : (
        <DesignStepContainer>
          {plumbingDisplayData.map(([product, data]) => (
            <DesignSectionCard
              style={{ width: '100%' }}
              key={`plumbing-${product.productId}`}
              title={data.title}
              image={data.image}
              isSelected={data.isSelected}
              onClick={handlePlumbingClick(product.productId)}
            >
              <p>{data.price}</p>
              {data.isSelected && (
                <ItemCountAdjustButton
                  quantity={data.quantity}
                  onIncrease={increaseQuantity(product.productId)}
                  onDecrease={decreaseQuantity(product.productId)}
                  onUpdateValue={setQuantity(product.productId)}
                />
              )}
            </DesignSectionCard>
          ))}
        </DesignStepContainer>
      )}

      <PlumbingModal
        isVisible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      />
    </>
  );
};

export default SidePanelPlumbingTab;
